module.exports = __webpack_public_path__ + "static/media/informationIcon.6427e113.svg";